import { Context } from "react-apollo";

export const getPaymentsContext = (): { context: Context } => ({
  context: {
    module: "payments"
  }
});
